// extracted by mini-css-extract-plugin
module.exports = {"pagMesInfo":"codiespectador_pagMesInfo__55hYP","clickable":"codiespectador_clickable__H3UNj"};